module.exports = __webpack_public_path__ + "img/countersquaresm2.7769d1ff.webp";